import { injectIntl } from 'react-intl';
import React, { useContext } from 'react';
import { Row, Col, Divider } from 'antd';
import myContext from '@/utils/createContext';

function OrderInfo(props) {
  const { intl } = props;
  const { formatMessage } = intl;
  const data = useContext(myContext);

  const {
    products,
    paymentCurrencySymbol,
    paymentCurrency,
    totalAmount,
    description,
    showEuropeFlag,
  } = data || {};

  return (
    <div className="h5pc-order-info">
      {products ?
        <>
          <div className="h5pc-order-info-detail">
            <div className="h5pc-order-info-label">
              {/* Order Information */}
              {formatMessage({ id: 'ga-checkout.order-information' })}
            </div>
            <div className="h5pc-order-info-context">{products}</div>
          </div>
          <Divider />
        </>
        :
        null
      }
      {showEuropeFlag ? (
        <div>
          <div className="h5pc-order-info-detail">
            <div className="h5pc-order-info-label">
              {/* Descriptor */}
              {formatMessage({ id: 'ga-checkout.description' })}
            </div>
            <div className="h5pc-order-info-context">{description}</div>
          </div>
          <Divider />
        </div>
      ) : null}

      <div className="h5pc-order-info-total">
        <div className="h5pc-order-info-label">
          {/* Payment Amount */}
          {formatMessage({ id: 'ga-checkout.payment-amount' })}
        </div>
        <div className="h5pc-order-info-context h5pc-order-info-total-amount">
          {paymentCurrencySymbol}&nbsp;
          {totalAmount}&nbsp;
          {paymentCurrency}
        </div>
      </div>
    </div>
  );
}

export default injectIntl(OrderInfo);
